import { render, staticRenderFns } from "./AttendeeComment.vue?vue&type=template&id=024afa4a"
import script from "./AttendeeComment.vue?vue&type=script&lang=js"
export * from "./AttendeeComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports